import { render, staticRenderFns } from "./tags-usage-report.vue?vue&type=template&id=15229e74"
import script from "./tags-usage-report.vue?vue&type=script&lang=js"
export * from "./tags-usage-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports